import axios from 'axios'
import qs from 'qs'
// create an axios instance
let token = '';
const service = axios.create({
    //baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        if(localStorage.getItem('token')){
            token = localStorage.getItem('token')
        }
        console.log("token",token)
        // if (store.getters.token) {
        //     // let each request carry token
        //     // ['X-Token'] is a custom headers key
        //     // please modify it according to the actual situation
        //     config.headers['X-Token'] = getToken()
        // }
        config.headers.common['token'] = token;
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        return res
    },
    error => {
        // console.log(error.response) // for debug
        // if(error.response)
        // Message({
        //     message: error.message,
        //     type: 'error',
        //     duration: 5 * 1000
        // })
        return Promise.reject(error)
    }
)

function http(config) {
    if (config.method.toLowerCase() == "post") {
        config.data = qs.stringify(config.data, { arrayFormat: 'repeat', allowDots: true })
    } else {
        config.params = config.data
    }
    return service(config);
}
export default http